import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import { ASSIGN_USER_TO_PROJECT, COMPONENT_RENDERING_URL, CREATE_COMPANY, CREATE_SUB_PROGRAM_URL, DEACTIVATE_PROJECT, DELETE_SUB_PROGRAM_URL, EDIT_PROJECT, GET_COMPANIES, GET_COMPANY_TYPES, GET_DEACTIVATED_PROJECT, get_headers, GET_USERS_ASSIGNED_TO_PROJECT, LIST_SUB_PROGRAMS_URL, UPDATE_SUB_PROGRAM_URL, USER_LIST_URLS, verify_super_user_status } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { validate_non_empty_string, validate_non_sub_zero_number } from '@/utils/validations/validate_inputs';
import axios from "axios";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';

export default {
  name: 'CompanyManagement',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    navbar,
    GlobalTable,
    AICampusFooter
  },
  data: () => ({
    headers: get_headers(),
    company_types: [],
    company_list: [],
    table_headers: [],
    company_name: '',
    table_safe_company_list: [],
    selected_company_type: '',
    company_description: '',
    project_id: '',
    company_count: 0,
    is_loading: false,
    role: sessionStorage.getItem('user_role') || null,
    sidebar_components: [], // Store sidebar components
    sorted_sidebar_components: [], // Store sorted sidebar components
    users: [],
    users_list: [],
    user_table_headers: [],
    assigned_users: [],
    deactivated_projects: [],
    update_company_name: '',
    update_company_description: '',
    update_selected_company_type: [],
    hostname: '',
    hero_title: '',
    hero_description: '',
    is_super_user: false,
    sub_programs: {},          // keyed by project_id
    expanded_programs: {},     // keyed by project_id (accordion state)
    create_sp_name: '',
    create_sp_description: '',
    create_sp_project_id: null,
    edit_sp_id: null,
    edit_sp_name: '',
    edit_sp_description: '',
    edit_sp_project_id: null,
    search_query: '',
    items_per_page: 10,
    current_page: 1,
    active_config_project: sessionStorage.getItem('project_id') || null,
    config_table_data: [],
  }),

  computed: {
    first_component_url() {
      // Get the first URL from sorted sidebar components
      const first_url = this.find_first_component_with_url(this.sorted_sidebar_components);
      return first_url || '/overview'; // Fallback to /overview if no URL found
    },
    
    filtered_company_list() {
      if (!this.search_query) {
        return this.table_safe_company_list;
      }
      const query = this.search_query.toLowerCase();
      return this.table_safe_company_list.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(query);
        });
      });
    },
    
    paginated_company_list() {
      const start = (this.current_page - 1) * this.items_per_page;
      const end = start + this.items_per_page;
      return this.filtered_company_list.slice(start, end);
    },
    
    total_pages() {
      return Math.ceil(this.filtered_company_list.length / this.items_per_page);
    }
  },
  mounted() {
    this.load_data();
    this.get_deactivated_projects();
    // safely define it once the component is mounted
    this.hostname = window.location.hostname || '';
    this.set_domain_content();
  },

    methods: {
      isSelectedProject(project_id) {
        return String(this.active_config_project) === String(project_id);
      },

    toggle_config_project(row) {

        const project_id = row.id;
        const company_name = row.Company;

      if (this.isSelectedProject(project_id)) return;

      this.active_config_project = project_id;

      sessionStorage.setItem("project_id", project_id);
      sessionStorage.setItem("company_name", company_name);

      this.show_success("Configuration project selected");

    },
    logout() {
      this.$router.push('/');
    },
    set_domain_content() {
      if (this.hostname.includes('trustfirst.probaanalytics')) {
        this.hero_title = 'Simplified Trust Administration and Registrations Solutions';
        this.hero_description = 'Trust us to Provide Solutions to your Trust Clients. Easy management of Trusts and Trusts assets with reliable, secure, and approved solutions by experienced Trust professionals.';
      }

      else{
        this.hero_title = 'Smart Case and Incident Management';
        this.hero_description = 'Manage cases and incidents with clarity, speed, and control from one intelligent workspace.';
      }
    },
    
    determine_sidebar(project_id) {
      const params = {
        role: this.role,
        project_id: project_id
      };
      return axios.get(COMPONENT_RENDERING_URL, {
        headers: this.headers,
        params
      })
        .then(response => {
          this.sidebar_components = response.data.data || [];
          this.sort_sidebar_components();
        })
        .catch(error => {
          this.show_error('Error getting sidebar configuration: ' + error);
          return [];
        });
    },

    sort_sidebar_components() {
      // Create a deep copy and sort the components
      const safe_components = (this.sidebar_components || []).map(component => {
        const safe_component = Object.assign({}, component || {});

        // Process sub-components
        safe_component.sub_components = (component.sub_components || [])
          .slice()
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
          .map(sub => {
            const safe_sub = Object.assign({}, sub || {});

            // Process child components
            safe_sub.child_components = (sub.child_components || [])
              .slice()
              .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

            return safe_sub;
          });

        return safe_component;
      });

      this.sorted_sidebar_components = safe_components.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    },

    find_first_component_with_url(components) {
      // Helper function to recursively find the first component with a URL
      const find_url = (component_list, parent_type = null) => {
        for (const component of component_list) {
          // Check if the main component has a URL
          if (component.url && component.url.trim() !== '') {
            // Determine the type based on context
            const item_type = parent_type === 'sub' ? 'child' : 'sub';
            sessionStorage.setItem('sidebar_active_item_key', `${item_type}:${component.id}`);
            return component.url;
          }

          // Check sub-components
          if (component.sub_components && component.sub_components.length > 0) {
            const sub_url = find_url(component.sub_components, 'component');
            if (sub_url) return sub_url;
          }

          // Check child components
          if (component.child_components && component.child_components.length > 0) {
            const child_url = find_url(component.child_components, 'sub');
            if (child_url) return child_url;
          }
        }
        return null;
      };

      return find_url(components || []);
    },

    async load_data() {
        this.is_loading = true;
          try {
            try {
              await Promise.all([
                this.is_super_user = await verify_super_user_status(),
                this.get_project_types(),
                this.get_companies(),
                this.fetch_users(),
              ]);
            } catch (error) {
              this.show_error('Error loading data: ' + error);
            }
          } finally {
            this.is_loading = false;
          }
    },

    role_class(role) {
      switch (role) {
        case "Admin":
          return "admin-badge";
        case "Owner":
          return "owner-badge";
        case "Member":
          return "member-badge";
        default:
          return "default-badge";
      }
    },

    get_project_types() {
      return this.show_loader("Loading company types...")
        .then(loader => {
          return axios.get(GET_COMPANY_TYPES, {
            headers: this.headers
          })
            .then(response => {
              const parsed_response = JSON.parse(response.data);
              if (parsed_response.data && parsed_response.data.length > 0) {
                this.company_types = parsed_response.data;
              } else {
                this.show_error('No company types found');
              }
              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error getting company types: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    get_companies() {
      this.company_list = [];
      return this.show_loader("Loading Companies...")
        .then(loader => {
          return axios.get(GET_COMPANIES, {
            headers: this.headers,
            params: { include_sub_programs: true },
          })
            .then(response => {
              const parsed_response = JSON.parse(response.data);
              if (parsed_response.data && parsed_response.data.length > 0) {
                this.company_list = parsed_response.data;
                this.company_count = this.company_list.length;
                this.prep_tables();
              }
              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error getting company: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    prep_tables() {

      this.table_headers = [
        "Company",
        "Description",
        "Type",
        "Date Created",
        "Assigned Administrator"
      ];

      const main_programs = this.company_list.filter(
        item => !item.parent_program
      );

      const sub_programs = this.company_list.filter(
        item => item.parent_program
      );

      const sub_program_map = {};

      sub_programs.forEach(sub => {

        const parent_id = sub.parent_program;

        if (!sub_program_map[parent_id]) {
          sub_program_map[parent_id] = [];
        }

        sub_program_map[parent_id].push({
          id: sub.id,
          Company: sub.name,
          Description: sub.project_description,
          Type: sub.project_type?.name || "-",
          "Date Created": this.format_date(sub.date_created),
          "Assigned Administrator": sub.creator?.full_name || "-",
          _is_sub_program: true,
          _parent_id: parent_id,
        });

      });

      const formatted_data = [];

      main_programs.forEach(company => {

        formatted_data.push({
          id: company.id,
          Company: company.name,
          Description: company.project_description,
          Type: company.project_type?.name || "-",
          "Date Created": this.format_date(company.date_created),
          "Assigned Administrator": company.creator?.full_name || "-",
          _is_sub_program: false
        });

        if (sub_program_map[company.id]) {

          sub_program_map[company.id].forEach(sub => {
            formatted_data.push(sub);
          });

        }

      });

      this.table_safe_company_list = formatted_data;

      /* ----------------------------
        CONFIGURE MODAL TABLE DATA
      ---------------------------- */

      this.config_table_data = main_programs.map(company => ({
      id: company.id,
      Company: company.name
    }));

    },

    open_company_or_sub_program(row) {
      if (row._is_sub_program) {
        this.redirect_to_sub_program_jobs(
          row._sub_program_id,
          row._sub_program_name,
          row._project_id,
        );
        return;
      }
      this.redirect_to_overview(row._project_id || row.id, row.Company);
    },

    async create_company() {
      const company_name = this.company_name;
      const company_description = this.company_description;
      const company_type = this.selected_company_type;

      if (!validate_non_empty_string(company_name)) {
        this.show_error('Company name must not be empty');
        return Promise.resolve();
      }

      if (!validate_non_empty_string(company_description)) {
        this.show_error('Company description must not be empty');
        return Promise.resolve();
      }

      if (!validate_non_sub_zero_number(company_type)) {
        this.show_error('Please select a valid company type');
        return Promise.resolve();
      }

      const loader = await this.show_loader("Creating Company");

      let payload = {
        project_name: company_name,
        project_description: company_description,
        project_type_id: company_type,
      };

      axios.post(CREATE_COMPANY, payload ,{headers: this.headers})
        .then(async (response) => {
          const response_data = JSON.parse(response.data);

          if (response_data.status === "success") {
            this.show_success("Company created successfully");

            // Close modal
            this.close_modal("create_company");

            // Refresh company list
            await this.get_companies();

            // Auto-select the newly created company
            const new_company = this.company_list.find(
              (c) => c.name === this.company_name
            );

            if (new_company) {
              this.active_config_project = new_company.id;

              sessionStorage.setItem("project_id", new_company.id);
              sessionStorage.setItem("company_name", new_company.name);
            }

            // Reset form fields
            this.company_name = "";
            this.company_description = "";
          } else {
            this.show_error(
              response_data.message || "Failed to create company"
            );
          }

          return this.close_loader(loader);
        })

        
        .catch((error) => {
          this.show_error(error.response.data.message);
          return this.close_loader(loader);
        });
    },

    redirect_to_overview(project_id, company_name) {
      this.project_id = project_id;
      this.company_name = company_name;
      sessionStorage.setItem('project_id', project_id);
      sessionStorage.setItem('company_name', company_name);
      sessionStorage.removeItem('sub_program_id');
      sessionStorage.removeItem('sub_program_name');
      sessionStorage.removeItem('sub_program_context');

      // Fetch sidebar for this specific project, then navigate
      this.determine_sidebar(project_id)
        .then(() => {
          this.$router.push({
            path: this.first_component_url,
          });
        })
        .catch(() => {
          this.$router.push({
            path: '/overview', // Fallback
          });
        });
    },

    redirect_to_config(project_id=null, company_name=null) {
      this.project_id = project_id;
      this.company_name = company_name;
      sessionStorage.setItem('project_id', project_id);
      sessionStorage.setItem('company_name', company_name);
      sessionStorage.removeItem('sub_program_id');
      sessionStorage.removeItem('sub_program_name');
      sessionStorage.removeItem('sub_program_context');
      this.$router.push({
        path: '/configure_company_management',
      });
    },

    async select_project(project_id) {
      this.assigned_users = [];
      this.project_id = project_id;

      const payload = { project_id: this.project_id };
      const response = await axios.post(GET_USERS_ASSIGNED_TO_PROJECT, payload, { headers: this.headers });

      if (response.data.data && Array.isArray(response.data.data)) {
        // Only store the IDs of assigned users
        this.assigned_users = response.data.data.map(item => item.assignee);
      } else {
        this.assigned_users = [];
      }
    },


    async fetch_users() {
      axios.get(USER_LIST_URLS, { headers: this.headers })
        .then(response => {
          const res = JSON.parse(response.data);

          this.users = res.data.map(user => ({
            user_id: user.user_id,
            name: (user.user.first_name && user.user.last_name)
              ? user.user.first_name + " " + user.user.last_name
              : "User has not logged in",
            email: user.user.email,
          }));

          this.users_list = this.users;
          this.user_table_headers = Object.keys(this.users_list[0]);
        })
        .catch(() => {
          this.show_error("Error fetching users");
        });
    },

    toggle_assignment(user_id) {
      const payload = {
        project_id: this.project_id,
        user_id: user_id
      };

      if (this.assigned_users.includes(user_id)) {
        payload.is_assigned = false;
      } else {
        payload.is_assigned = true;
      }

      axios.post(ASSIGN_USER_TO_PROJECT, payload, { headers: this.headers })
        .then(() => {
          if (payload.is_assigned) {
            this.assigned_users.push(user_id);
          } else {
            this.assigned_users = this.assigned_users.filter(id => id !== user_id);
          }
        })
        .catch(() => {
          this.show_error("Error fetching users");
        });
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_element = document.getElementById('deactivated_projects_table');
        
        // Check if element exists
        if (!table_element) {
          return;
        }
        
        const $table = $('#deactivated_projects_table');
        
        // Destroy existing DataTable if it exists
        if ($.fn.DataTable.isDataTable('#deactivated_projects_table')) {
          $table.DataTable().destroy();
        }
        
        // Initialize new DataTable
        $table.DataTable({
          responsive: true,
          destroy: true,
          language: {
            emptyTable: "No data available in the table",
            info: "",
            lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page"
          }
        });
      });
    },

    deactivate_company(project_id){
      this.show_confirm(
        "Deactivate Company",
        "Are you sure you want to deactivate this company?",
        ()=>{
          const payload = {
            project_id: project_id
          }

          axios.post(DEACTIVATE_PROJECT, payload, {
            headers: this.headers
          }).then(response => {
            const response_data = JSON.parse(response.data);
            if (response_data.status === "success") {
              this.show_success("Company successfully deactivated");
              window.location.reload();

            } else {
              this.show_error(response_data.message || "Failed to deactivate company");
            }
          })
          .catch(error => {
            this.show_error("Error deactivating company: " + error);
        })})
      },

    get_deactivated_projects() {
      axios.get(GET_DEACTIVATED_PROJECT, { headers: this.headers })
        .then(response => {
          const parsed_response = JSON.parse(response.data);
          if (parsed_response.status === "success") {
            this.deactivated_projects = parsed_response.data;
            this.$nextTick(() => this.initialize_data_table());
          } else {
            this.show_error(parsed_response.message || "No deactivated company found");
          }
        })
        .catch(error => {
          this.show_error("Error fetching deactivated companies: " + error);
      });
    },


    prepopulate_update_company_modal(project_id){
      const project = this.company_list.find(c => c.id === project_id);
      if (!project) return;

      this.project_id = project.id;
      this.update_company_name = project.name || '';
      this.update_company_description = project.project_description || '';
      this.update_selected_company_type = project.project_type?.id || '';
    },

    update_project(){
      if (!validate_non_empty_string(this.update_company_name)) {
        this.show_error('Company name must not be empty');
        return;
      }
      if (!validate_non_empty_string(this.update_company_description)) {
        this.show_error('Company description must not be empty');
        return;
      }
      if (!validate_non_sub_zero_number(this.update_selected_company_type)) {
        this.show_error('Please select a valid Company type');
        return;
      }

      const payload ={
        project_id: this.project_id,
        project_name: this.update_company_name,
        project_description: this.update_company_description,
        project_type_id: this.update_selected_company_type,
      }

      axios.post(EDIT_PROJECT, payload,{
        headers: this.headers
      }).then(response => {
        const response_data = JSON.parse(response.data);
        if (response_data.status === "success") {
          this.show_success("Company updated successfully");
          this.close_modal("update_company")
          window.location.reload();
        } else {
          this.show_error(response_data.message || "Failed to update company");
        }
      })
      .catch(error => {
        this.show_error("Error updating company: " + error);
      })
    },

    // ═══════════════════════════════════════════════════
    // Sub-program methods
    // ═══════════════════════════════════════════════════
    toggle_program_accordion(project_id) {
      this.expanded_programs = { ...this.expanded_programs, [project_id]: !this.expanded_programs[project_id] };
      if (this.expanded_programs[project_id] && !this.sub_programs[project_id]) {
        this.fetch_sub_programs(project_id);
      }
    },

    async fetch_sub_programs(project_id) {
      try {
        const response = await axios.get(LIST_SUB_PROGRAMS_URL, {
          headers: this.headers,
          params: { project_id },
        });
        if (response.data.status === 'success') {
          this.sub_programs = { ...this.sub_programs, [project_id]: response.data.data || [] };
        }
      } catch {
        this.sub_programs = { ...this.sub_programs, [project_id]: [] };
      }
    },

    open_create_sub_program(project_id) {
      this.create_sp_project_id = project_id;
      this.create_sp_name = '';
      this.create_sp_description = '';
    },

    async create_sub_program() {
      const name = (this.create_sp_name || '').trim();
      if (!name) {
        this.show_error('Please enter a sub-company name.');
        return;
      }
      try {
        const response = await axios.post(CREATE_SUB_PROGRAM_URL, {
          name,
          description: (this.create_sp_description || '').trim(),
          project_id: this.create_sp_project_id,
        }, { headers: this.headers, withCredentials: true });
        if (response.data.status === 'success') {
          this.show_success('Sub-company created successfully.');
          this.create_sp_name = '';
          this.create_sp_description = '';
          this.close_modal('create_sub_program_modal');
          await this.fetch_sub_programs(this.create_sp_project_id);
        } else {
          this.show_error(response.data.message || 'Failed to create sub-company.');
        }
      } catch (err) {
        this.show_error(err?.response?.data?.message || 'Failed to create sub-company.');
      }
    },

    open_edit_sub_program(sp, project_id) {
      this.edit_sp_id = sp.id;
      this.edit_sp_name = sp.name;
      this.edit_sp_description = sp.description || '';
      this.edit_sp_project_id = project_id;
    },

    async save_edit_sub_program() {
      const name = (this.edit_sp_name || '').trim();
      if (!name) {
        this.show_error('Sub-company name cannot be empty.');
        return;
      }
      try {
        const response = await axios.post(UPDATE_SUB_PROGRAM_URL, {
          sub_program_id: this.edit_sp_id,
          name,
          description: (this.edit_sp_description || '').trim(),
        }, { headers: this.headers, withCredentials: true });
        if (response.data.status === 'success') {
          this.show_success('Sub-programme updated.');
          this.close_modal('edit_sub_program_modal');
          await this.fetch_sub_programs(this.edit_sp_project_id);
        } else {
          this.show_error(response.data.message || 'Failed to update sub-company.');
        }
      } catch (err) {
        this.show_error(err?.response?.data?.message || 'Failed to update sub-company.');
      }
    },

    async delete_sub_program(sp_id, project_id) {
      if (!confirm('Are you sure you want to delete this sub-company?')) return;
      try {
        const response = await axios.post(DELETE_SUB_PROGRAM_URL, {
          sub_program_id: sp_id,
        }, { headers: this.headers, withCredentials: true });
        if (response.data.status === 'success') {
          this.show_success('Sub-company deleted.');
          await this.fetch_sub_programs(project_id);
        } else {
          this.show_error(response.data.message || 'Failed to delete sub-company.');
        }
      } catch (err) {
        this.show_error(err?.response?.data?.message || 'Failed to delete sub-company.');
      }
    },

    redirect_to_sub_program_jobs(sp_id, sp_name, project_id) {
      sessionStorage.setItem('project_id', project_id);
      sessionStorage.setItem('sub_program_id', sp_id);
      sessionStorage.setItem('sub_program_name', sp_name);
      sessionStorage.setItem('sub_program_context', '1');
      this.$router.push({ path: '/manage_entity_type' });
    },

    format_date_short(val) {
      if (!val) return '-';
      return new Date(val).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },


  },
}
